import { ReservationResponse } from "../types/ReservationTypes";
import { Driver as DriverInfo } from "../types/DriverTypes";
import { CarInfo } from "../types/CarInfo";

export interface AuthState {
  subDriver: boolean;
  totalPrice: number;
  directDriver: boolean;
  resInfo: ResInfo | null;
  carInfo: ResCarInfo | null;
  kioskInfo: KioskInfo | null;
  resOneInfo: ResOneInfo | null;
  product: Product | null;
  driver: Driver | null;
  file: FileList | null;
  signFile: Array<any> | null;
  loading: boolean;
  loginUserId: LoginUserId | null;
  memberRegFlag: memberRegFlag | null;
}

export interface ResInfo {
  data: ReservationResponse;
}

export interface ResOneInfo {
  data: ReservationResponse;
}

export interface Product {
  data: any;
}

export interface KioskInfo {
  data: any;
}

export interface ResCarInfo {
  data: CarInfo;
}

export interface Driver {
  data: DriverInfo[] | null;
}

export interface LoginUserId {
  data: any;
}

export interface memberRegFlag {
  data: any;
}

export type AuthAction =
  | { type: "IN" }
  | { type: "OUT" }
  | { type: "PRICE"; payload: number }
  | { type: "DIRECT" }
  | { type: "PRODUCT"; payload: any }
  | { type: "DRIVER"; payload: DriverInfo[] }
  | { type: "CARINFO"; payload: CarInfo }
  | { type: "RESERVATION"; payload: any }
  | { type: "RESERVATION_ONE"; payload: ReservationResponse }
  | { type: "FILE"; payload: FileList | null }
  | { type: "SIGN_FILE"; payload: Array<any> | null }
  | { type: "LOADING" }
  | { type: "LOADED" }
  | { type: "SET_KIOSK"; payload: any }
  | { type: "DRIVER_CLEAR" }
  | { type: "PRODUCT_RESET" }
  | { type: "LOGIN_USER_ID"; payload: any }
  | { type: "MEMBER_REG_FLAG"; payload: any }
const initialState: AuthState = {
  subDriver: false,
  directDriver: false,
  resInfo: null,
  resOneInfo: null,
  product: null,
  driver: null,
  file: null,
  signFile: [],
  loading: false,
  carInfo: null,
  totalPrice: 0,
  kioskInfo: null,
  loginUserId: null,
  memberRegFlag: null,
};

const authReducer = (
  state: AuthState = initialState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case "IN":
      return {
        ...state,
        subDriver: true,
      };
    case "OUT":
      return {
        ...state,
        subDriver: false,
      };
    case "PRICE":
      return {
        ...state,
        totalPrice: action.payload,
      };
    case "DIRECT":
      return {
        ...state,
        directDriver: false,
      };
    case "RESERVATION":
      return {
        ...state,
        resInfo: {
          data: action.payload,
        },
      };
    case "RESERVATION_ONE":
      return {
        ...state,
        resOneInfo: {
          data: action.payload,
        },
      };
    case "PRODUCT":
      return {
        ...state,
        product: {
          data: action.payload,
        },
      };
    case "DRIVER":
      return {
        ...state,
        driver: {
          data: action.payload,
        },
      };
    case "CARINFO":
      return {
        ...state,
        carInfo: {
          data: action.payload,
        },
      };
    case "SET_KIOSK":
      return {
        ...state,
        kioskInfo: {
          data: action.payload,
        },
      };
    case "FILE":
      return {
        ...state,
        file: action.payload,
      };
    case "SIGN_FILE":
      return {
        ...state,
        signFile: action.payload,
      };
    case "LOADING": {
      return {
        ...state,
        loading: true,
      };
    }
    case "LOADED": {
      return {
        ...state,
        loading: false,
      };
    }
    case "DRIVER_CLEAR": {
      return {
        ...state,
        driver: null // 상태를 null로 초기화
      };
    }
    case "PRODUCT_RESET":
      return {
        ...state,
        product: null
      };
    case "LOGIN_USER_ID": {
      return {
        ...state,
        loginUserId: action.payload,
      };
    }
    case "MEMBER_REG_FLAG": {
      return {
        ...state,
        memberRegFlag: action.payload,
      };
    }
    default:
      return state;
  }
};

export default authReducer;
